import { getVersion, sendableSteps } from 'prosemirror-collab';
import { EditorView } from 'prosemirror-view';
import { pluginKey } from './firestoreCollaborationPlugin';

/**
 * Updates the editor view with the latest changes and sends any new steps to the server.
 * @param editorView The editor view to update.
 * @returns void
 * @throws Error if plugin state is not defined.
 */
export function onUpdate(editorView: EditorView): void {
  const pluginState = pluginKey.getState(editorView.state);
  if (!pluginState) {
    throw new Error('Plugin state is not defined');
  }
  const { sendDocumentUpdateSteps, versionListener } = pluginState;
  const newState = editorView.state.apply(editorView.state.tr);
  if (!newState) return;
  // get steps that can be sent to the server. Undefined if there are no steps to send.
  const sendable = sendableSteps(newState);
  if (sendable) {
    sendDocumentUpdateSteps(
      sendable.version,
      sendable.steps.map((step) => step.toJSON()),
      sendable.clientID,
    );
  }
  if (versionListener) {
    const version = getVersion(newState);
    versionListener(version);
  }
}
